<div class="option-button-group" [class.option-button-group--disabled]="disabled" [class.variant]="isColorVariant">
	<p *ngIf="label || labelKey" class="label-default">
		<ng-container *ngIf="label; else translatedLabelTpl">{{ label }}</ng-container>
		<ng-template #translatedLabelTpl>{{ labelKey | translate }}</ng-template>
	</p>

	<div class="option-button-group__options">
		<button
			type="button"
			class="option-button-group__button paragraph-medium"
			[class.option-button-group__button--selected]="isSelected(null)"
			[disabled]="disabled"
			(click)="selectOption(null)"
		>
			{{ anyLabelKey | translate }}
		</button>

		<button
			*ngFor="let option of options; trackBy: trackByValue"
			type="button"
			class="option-button-group__button paragraph-medium"
			[class.option-button-group__button--selected]="isSelected(option.value)"
			[disabled]="disabled"
			(click)="selectOption(option.value)"
		>
			<ng-container *ngIf="option.label; else translatedOptionTpl">{{ option.label }}</ng-container>
			<ng-template #translatedOptionTpl>{{ option.labelKey | translate }}</ng-template>
		</button>
	</div>
</div>
